document.addEventListener('DOMContentLoaded', function () {
    // Initial application of styles
    applyKlaviyoFontStyles();

    // Also apply styles after a short delay to catch elements loaded by Klaviyo
    setTimeout(applyKlaviyoFontStyles, 1000);
    setTimeout(applyKlaviyoFontStyles, 2000);

    // Check for Klaviyo elements periodically
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                // Check if any Klaviyo elements were added
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];
                    if (node.querySelector &&
                        (node.querySelector('.klaviyo-form') ||
                            node.querySelector('[class*="needsclick"]'))) {
                        applyKlaviyoFontStyles();
                        break;
                    }
                }
            }
        });
    });

    // Start observing the document
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Function to apply Hero font to Klaviyo elements
    function applyKlaviyoFontStyles() {
        // Target all Klaviyo input fields
        const klaviyoInputs = document.querySelectorAll('.needsclick[type="email"], .klaviyo-form input[type="email"]');
        klaviyoInputs.forEach(input => {
            input.style.fontFamily = "'Hero', sans-serif";

            // Also ensure the placeholder has the correct font
            if (input.hasAttribute('placeholder')) {
                // Force a redraw of the placeholder by briefly removing and re-adding it
                const placeholder = input.getAttribute('placeholder');
                input.setAttribute('placeholder', '');
                setTimeout(() => {
                    input.setAttribute('placeholder', placeholder);
                }, 10);
            }
        });

        // Target all Klaviyo buttons
        const klaviyoButtons = document.querySelectorAll('button.needsclick, .klaviyo-form button');
        klaviyoButtons.forEach(button => {
            button.style.fontFamily = "'Hero', sans-serif";
            button.style.fontWeight = "900";
        });
    }
}); 